module.exports = __webpack_public_path__ + "img/database-task.2030f92e.svg";